import { useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { Link, useNavigate } from "react-router-dom";
import { createAdHocSurveyAsync } from "../../Helpers/API/AdHocSurveyApi";
import countAttendeesAsync from "../../Helpers/API/AttendeesApi";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import SurveyMissing from "../Surveys/SurveyMissing";
import AdHocSurveyForm from "./AdHocSurveyForm";

const CreateAdHocSurvey = () => {
	const [surveyMissing, setSurveyMissing] = useState(false);

	const navigate = useNavigate();
	const formValues = {
		name: "",
		alchemerId: "",
		emailTemplate: "",
		sendSurveyOn: "",
		windowStartDate: "",
		windowEndDate: "",
		rules: [],
	};

	const onSubmit = (adHocsurveyObject) => {
		async function createSurvey() {
			const { success, isSurveyMissing } = await createAdHocSurveyAsync(adHocsurveyObject);
			if (success) navigate("/adhoc-surveys");
			setSurveyMissing(isSurveyMissing);
		}

		async function createAdHocSurvey() {
			const { attendeeCount } = await countAttendeesAsync(adHocsurveyObject.rules, adHocsurveyObject.windowStartDate, adHocsurveyObject.windowEndDate);

			ConfirmDialog({
				operation: "create",
				confirmationText: "Create it",
				entityName: `${attendeeCount} surveys`,
				onDelete: createSurvey,
			});
		}
		createAdHocSurvey();
	};

	return (
		<div>
			<div className="breadcrumbs">
				<Breadcrumb>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>
						Home
					</Breadcrumb.Item>
					<Breadcrumb.Item linkAs={Link} linkProps={{ to: "/adhoc-surveys" }}>
						Ad-hoc Surveys
					</Breadcrumb.Item>
					<Breadcrumb.Item active>New Ad-Hoc Survey</Breadcrumb.Item>
				</Breadcrumb>
			</div>
			<SurveyMissing isSurveyMissing={surveyMissing} />
			<AdHocSurveyForm initialValues={formValues} saveText="Create ad-hoc survey" headerText="Create a new ad-hoc survey" onSubmit={onSubmit} />
		</div>
	);
};

export default CreateAdHocSurvey;
